import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import type { PropsWithChildren, ReactNode } from 'react';

import { ConflictResolver } from 'src/features/conflict-resolver';
import { Header } from 'src/features/header/header';
import { ConfirmRemoveVersionModal } from 'src/features/modals/confirm-remove-version-modal';
import { EditPublicDraftModal } from 'src/features/modals/edit-public-draft-modal';
import { Sidebar } from 'src/features/sidebar/sidebar';
import { checkIsPortableDevice } from 'src/shared/utils/check-is-portable-device';

import styles from './styles.module.scss';

type Props = PropsWithChildren<{
  title: string;
  headerCustomComponent?: ReactNode;
  sidebarWithoutClosedState?: boolean;
}>;

export const MainLayout: React.FC<Props> = observer(function MainLayout({
  title,
  headerCustomComponent,
  children,
  sidebarWithoutClosedState,
}) {
  return (
    <div
      className={clsx(
        styles.wrapper,
        checkIsPortableDevice() && styles.wrapper_portable,
        sidebarWithoutClosedState && styles.wrapper__full,
      )}
    >
      <Sidebar withoutClosedState={sidebarWithoutClosedState} />

      <div className={styles.contentWrapper}>
        <Header title={title}>{headerCustomComponent}</Header>
        <div className={clsx(styles.childrenWrapper, sidebarWithoutClosedState && styles.childrenWrapper__full)}>
          {children}
        </div>
      </div>

      <ConflictResolver />
      <EditPublicDraftModal />
      <ConfirmRemoveVersionModal />
    </div>
  );
});
